// const observeStickyElement = (element : HTMLElement) => {

//     const observer = new IntersectionObserver(
//         ([entry]) => {
//             const isStuck = entry.boundingClientRect.top < 1;

//             if (isStuck) {
//                 element.classList.add("stuck");
//             } else {
//                 element.classList.remove("stuck");
//             }
//         },
//         {
//             threshold: [1],
//             rootMargin: "-1px 0px 0px 0px",
//         }
//     );

//     observer.observe(element);

//     // Return cleanup function
//     return () => observer.disconnect();
// };

// const isSticky = document.querySelectorAll<HTMLElement>(".is-sticky");

// const initObservers = () => {
//     isSticky.forEach((element) => {
//         observeStickyElement(element);
//     });
// };

// if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", initObservers);
// } else {
//     initObservers();
// }
